import React from "react";
import { useGlobalGPS } from "./GPSContext";
import { FaMapMarkerAlt, FaTrashAlt } from "react-icons/fa";
import { Button, Card } from "react-bootstrap";
import Swal from "sweetalert2";

const GPSDistanceTracker = () => {
  const { distanceToday, isTracking, gpsOnline, resetDistance } = useGlobalGPS();

  const gpsActive = isTracking || gpsOnline;

  const handleReset = () => {
    Swal.fire({
      title: "¿Reiniciar distancia?",
      text: "Se borrará el recorrido de hoy (" + distanceToday.toFixed(2) + " km).",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#191919",
      confirmButtonText: "Sí, reiniciar"
    }).then((result) => {
      if (result.isConfirmed) {
        resetDistance();
      }
    });
  };

  return (
    <Card className="border-0 shadow-sm rounded-16 mb-4">
      <Card.Body className="p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <div className={`gps-status-circle ${gpsActive ? 'pulse-red' : ''}`}>
              <FaMapMarkerAlt color={gpsActive ? "var(--bry-accent)" : "#AFAFAF"} size={20} />
            </div>
            <div>
              <div className="small-label m-0">Recorrido de hoy</div>
              <div className="fw-bold h4 m-0">{distanceToday.toFixed(2)} <small className="text-muted">km</small></div>
            </div>
          </div>
          <div className="d-flex gap-2">
            {distanceToday > 0 && (
              <Button variant="light" className="rounded-pill px-3 py-2" onClick={handleReset}>
                <FaTrashAlt />
              </Button>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GPSDistanceTracker;
